/* eslint eqeqeq: 0 */
import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { BODY_TEXT_COLOR, NEGATIVE_COLOR, THIRD_COLOR } from '../../config/colors'
import { HeaderDiv, HeaderIconImg, HeaderTitleDiv } from '../../pages';
import PurchasedItem from '../../components/PurchasedItem';
import styled from 'styled-components';
import * as historyReducer from '../../reducers/historyReducer';
import { checkOutUri, ordersUri } from '../../config/uri';

import { getTicketDetails } from '../../services/tickets';
import { formatDate, formatDateMmDdHHmm } from '../../helpers/date.js';
import RaisedButton from 'material-ui/RaisedButton';
import { addProducts, cartUpdated } from '../../reducers/cartReducer'
import { unUpdateOrder } from '../../actions/order';
import LinearProgress from 'material-ui/LinearProgress';
import { isPaymentKiosk } from '../../selectors/configSelectors';
import { isDelivery } from '../../selectors/address';
import { openModal } from '../../reducers/modalReducer';
import { getKioskSettings, addPaymentAndGetStatus, PAYMENT_STATUS } from '../../actions/pots-api';
import { processKioskPayment } from '../../actions/ticket.js';
import { OUT_FOR_DELIVERY } from '../../const/orderStatus';
import { getFullName } from '../../reducers/customerReducer';
import { groupBy } from '../../helpers/object_util';

import './style.css'
import { getProductsById } from '../../actions/api';
import { convertProductToCartItem } from '../../helpers/productHelper';
import CustomerType from '../../const/customer_type';
import { isValidAddProductByCustomerType } from '../../selectors/cartSelectors';
import { ADULT_CAN_ONLY_BUY_REC_MESSAGE, PRODUCT_OUT_OF_STOCK_MESSAGE } from '../../const/cart_const';
import { pushWithQueryParams } from '../../services/uri';

const pendingIcon = process.env.PUBLIC_URL + '/assets/img/icons/order/paper-clock.svg';
const awaitingIcon = process.env.PUBLIC_URL + '/assets/img/icons/order/clock.svg';
const inprocessIcon = process.env.PUBLIC_URL + '/assets/img/icons/order/inprocess.svg';
const packedNreadyIcon = process.env.PUBLIC_URL + '/assets/img/icons/order/packed.svg';
const deliveryIcon = process.env.PUBLIC_URL + '/assets/img/icons/order/delivery.svg';
const completeIcon = process.env.PUBLIC_URL + '/assets/img/icons/order/complete.svg';

const trackOrder1Icon = process.env.PUBLIC_URL + '/assets/img/icons/TrackOrder/ProgressBar1.svg';
const trackOrder2Icon = process.env.PUBLIC_URL + '/assets/img/icons/TrackOrder/ProgressBar2.svg';
const trackOrder3Icon = process.env.PUBLIC_URL + '/assets/img/icons/TrackOrder/ProgressBar3.svg';
const trackOrder4Icon = process.env.PUBLIC_URL + '/assets/img/icons/TrackOrder/ProgressBar4.svg';
const trackOrder5Icon = process.env.PUBLIC_URL + '/assets/img/icons/TrackOrder/ProgressBar5.svg';
const trackOrder6Icon = process.env.PUBLIC_URL + '/assets/img/icons/TrackOrder/ProgressBar6.svg';
const pastOrdersDark = process.env.PUBLIC_URL + '/assets/img/icons/menu/order_dark.svg';

const styles = {
  headerIcon: { width: '30px', height: '30px' },
  closeIconWrap: { "position": "absolute", "left": "20px", top: '5px', cursor: 'pointer' },
  closeIcon: { height: '50px', width: '50px', color: THIRD_COLOR },
  labelStyle: { fontWeight: 700 },
  payForOrderButtonStyle: { height: '120px' },
  payForOrderLabelStyle: { fontWeight: 700, fontSize: '40px' },
};

const STATUS_ICONS = {
  VERIFICATION_PENDING: pendingIcon,
  AWAITING_PROCESSING: awaitingIcon,
  IN_PROCESS: inprocessIcon,
  PACKED_READY: packedNreadyIcon,
  OUT_FOR_DELIVERY: deliveryIcon,
  COMPLETED: completeIcon,
  CANCELED: completeIcon,
  REMOVED: completeIcon,
};

const STATUS_DESCRIPTION = {
  VERIFICATION_PENDING: 'Verification Pending',
  AWAITING_PROCESSING: 'Awaiting Processing',
  IN_PROCESS: 'In Process',
  PACKED_READY: 'Packed and Ready',
  OUT_FOR_DELIVERY: 'Out for delivery with Onfleet',
  COMPLETED: 'Complete',
  CANCELED: 'Canceled',
  REMOVED: 'Removed',
};

const openMissingPaymentKioskSettingsModal = () => openModal({
  modalType: 'GENERIC',
  modalProps: {
    text: 'Payment Kiosk settings are missing',
    stay: true
  }
});

const openThankYouPaymentKioskModal = () => openModal({
  modalType: 'PAYMENT_KIOSK_ORDER_COMPLETE_FORM',
  modalProps: {}
});

const openAdultCanOnlyBuyRecModal = () => openModal({
  modalType: 'MESSAGE_MODAL',
  modalProps: { message: ADULT_CAN_ONLY_BUY_REC_MESSAGE }
});

const openProductsOutOfStockModal = () => openModal({
  modalType: 'MESSAGE_MODAL',
  modalProps: { message: PRODUCT_OUT_OF_STOCK_MESSAGE }
});

class OrderHistory extends Component {
  secondaryColor = '#' + this.props.secondaryColor;
  reorderBtnStyle = { color: '#fff', background: this.secondaryColor };

  state = {
    activeTab: 'cart',
    showBadge: false,
    isLoading: false,
    ticket: null,
    orderNumber: null,
    orderDate: null,
    status: null,
    statusDescription: null,
    items: [],
    history: [],
    subTotal: 0,
    total: 0,
    taxTotal: 0,
    discountTotal: 0,
    tierDiscountTotal: 0,
    rewardDiscountTotal: 0,
    adjustedSubtotal: 0,
    deliveryFee: 0
  }

  componentDidMount() {
    this.getOrder();
  }

  isCartTab = () => {
    return this.state.activeTab === 'cart';
  }

  isTrackOrderTab = () => {
    return this.state.activeTab === 'track_order';
  }

  isItemChecked = () => {
    const checked = this.state.items.filter(item => item.checked);
    return checked.length > 0;
  }

  setIsLoading = (isLoading) => {
    this.setState({ isLoading: isLoading });
  }

  selectAllItems = (items) => items.map(item => {
    return {
      ...item,
      checked: true,
    }
  });

  getOrder = () => {
    const orderId = this.props.match.params.orderId;

    this.setIsLoading(true);

    getTicketDetails(orderId)
      .then((res) => {
        const data = res.data;

        this.setState({
          ticket: data.ticket,
          orderNumber: data.ticket.orderNumber,
          orderDate: data.ticket.dateCreated,
          status: data.ticket.status,
          statusDescription: STATUS_DESCRIPTION[data.ticket.status],
          items: this.selectAllItems(data.ticket.items),
          history: data.history,
          subTotal: data.ticketTotals.subTotal || 0,
          total: data.ticketTotals.total || 0,
          taxTotal: data.ticketTotals.taxTotal || 0,
          discountTotal: data.ticketTotals.discountTotal || 0,
          rewardDiscountTotal: data.ticketTotals.rewardDiscountTotal || 0,
          tierDiscountTotal: data.ticketTotals.tierDiscountTotal || 0,
          adjustedSubtotal: data.ticketTotals.adjustedSubtotal || 0,
          deliveryFee: data.ticketTotals.deliveryFee || 0,
        });

        this.setIsLoading(false);
      })
      .catch((err) => {
        console.warn(err);
      });
  }

  getOrderProgress = (status, index, len) => {
    const progressLineHeight = index + 1 < len ? status.type == OUT_FOR_DELIVERY ? '80px' : '100%' : '0px';
    const statusIconPath = STATUS_ICONS[status.status];
    const dateTimeObj = formatDateMmDdHHmm(new Date(status.date));

    return (
      <OrderProgress key={index}>
        <ProgressLine heightLen={progressLineHeight}></ProgressLine>
        <StatusLogo src={statusIconPath} />
        {status.type === OUT_FOR_DELIVERY && <StatusLogoLast src={completeIcon} />}
        <ProgressStatus>
          <div>{dateTimeObj.date} {dateTimeObj.time}<span className="hour12">{dateTimeObj.hour12}</span> &ndash; {STATUS_DESCRIPTION[status.status]}</div>
          <div>{status.description}</div>
        </ProgressStatus>
      </OrderProgress>
    )
  }

  getProgess = () => {
    const lastStatus = this.state.history[this.state.history.length - 1].status;
    switch (lastStatus) {
      case 'COMPLETED': return 100;
      case 'CANCELED': return 100;
      case 'REMOVED': return 100;
      case 'VERIFICATION_PENDING': return 10;
      case 'AWAITING_PROCESSING': return 20;
      case 'IN_PROCESS': return 50;
      case 'PACKED_READY': return 70;
      case 'OUT_FOR_DELIVERY': return 90;
      default: return 0;
    }
  }

  getProgressImage(progress) {
    if (progress == 100)
      return trackOrder6Icon;
    if (progress == 90)
      return trackOrder5Icon;
    if (progress == 70)
      return trackOrder4Icon;
    if (progress == 50)
      return trackOrder3Icon;
    if (progress == 20)
      return trackOrder2Icon;
    if (progress == 10)
      return trackOrder1Icon;
  }

  checkDisabled = () => {
    return this.state.isLoading;
  };

  handleItemCheck = (index) => {
    const items = this.getItemsGroupedByProductIdAndQuantity().map(item => item);
    const item = items[index];

    item.checked = !item.checked;
    items[index] = item;
    this.setState({ items });
  }

  handleTabClick = (tabName) => {
    if (this.checkDisabled()) {
      return;
    }

    if (tabName === 'track_order') {
      this.setState({
        showBadge: false
      });

      this.props.unUpdate(this.state.orderNumber);
    }

    this.setState({
      activeTab: tabName,
    })
  }

  handleBackBtn = () => {
    this.props.go(ordersUri);
  }

  handleReorderClick = () => {
    if (this.checkDisabled()) {
      return;
    }

    const { ticket } = this.state;

    const customerType = ticket.customerType.indexOf(CustomerType.MEDICAL) > -1 ? CustomerType.MEDICAL : CustomerType.ADULT;

    const getProductsPromises = 
      this.state.items
        .filter(item => item.checked)
        .map(item => new Promise((resolve, reject) => this.props.getProductById(item.type, item.productId, customerType).then(data => resolve(data))));

    Promise.all(getProductsPromises).then((values) => {
      const productGroups = values
        .filter(data => data && data.productGrouplist && data.productGrouplist.length)
        .flatMap(data => data.productGrouplist);

      const { items } = this.state;

      const productNotAbleToAddByCustomerType = items.find(item => { 
        const product = productGroups.find(p => p.categoryId == item.productId);

        return product && !this.props.isValidAddProductByCustomerType(product, customerType) ;
      });

      if (productNotAbleToAddByCustomerType) {
        this.props.openAdultCanOnlyBuyRecModal();
        return;
      }

      const productGroupsByCategoryId = _.groupBy(productGroups, 'categoryId');

      const products = items
        .filter(item => productGroupsByCategoryId[item.productId])
        .map((item) => {
          const product = productGroupsByCategoryId[item.productId][0];

          return convertProductToCartItem(product, product.productList[0], item.quantity);
        });

      if (_.isEmpty(products)) {
        this.props.openProductsOutOfStockModal();
        return;
      }

      this.props.addProducts(products);
      this.props.showCart();
    });
  };

  handlePayForOrderClick = async () => {
    if (this.checkDisabled()) {
      return;
    }

    const { showMissingPaymentKioskSettingsModal, showThankYouPaymentKioskModal } = this.props;

    this.setIsLoading(true);

    let kioskSettings;

    try {
      const getKioskSettingsResult = await getKioskSettings();

      if (typeof getKioskSettingsResult !== 'undefined' && getKioskSettingsResult !== null) {
        kioskSettings = getKioskSettingsResult.data;
      }
    }
    catch (err) {
      kioskSettings = null;
    }
    finally {
      this.setIsLoading(false);
    }

    if (typeof kioskSettings === 'undefined' || kioskSettings === null) {
      showMissingPaymentKioskSettingsModal();

      return;
    }

    this.setIsLoading(true);

    const orderId = this.props.match.params.orderId;
    const orderNumber = this.state.orderNumber;
    const customerName = this.props.customerName;
    const amountToPaid = this.state.total;

    try {
      const addPaymentResult = await addPaymentAndGetStatus(amountToPaid);

      if (addPaymentResult.status === PAYMENT_STATUS.COMPLETED) {
        const potsTid = addPaymentResult.potsTid;

        await processKioskPayment(orderId, orderNumber, customerName, amountToPaid, potsTid);

        showThankYouPaymentKioskModal();
      }
    }
    catch (err) {
      console.warn(err);
    }
    finally {
      this.setIsLoading(false);
    }
  };

  getItemsGroupedByProductIdAndQuantity() {
    const {
      items,
    } = this.state;

    return Object.values(
      groupBy(items, 'productId', 'quantity'),
    );
  }

  areAllItemsSelected = () => {
    const {
      items,
    } = this.state;
    return items.filter(item => item.checked).length === items.length;
  };

  renderItems = () => {
    return this.getItemsGroupedByProductIdAndQuantity().map((item, index) => (
      <PurchasedItem
        color={(item.checked ? this.secondaryColor : '#e6e6e6')}
        onClick={this.handleItemCheck.bind(null, index)}
        key={item.name}
        item={item}
      />
    ));
  }

  renderUpdated = () => {
    const item = this.props.orders.find(item => {
      if (item.orderId === this.props.match.params.orderId && item.changed) {
        return true;
      }
      return false;
    });

    if (!item) return null;
    return (<div className="updated">&nbsp;</div>);
  }

  getButtonTitle = () => {
    return this.areAllItemsSelected() ? 'Reorder All' : 'Reorder';
  }

  renderReorder() {
    if (this.isTrackOrderTab()) return null;

    return (
      <BottomButtonsWrapperDiv>
        <RaisedButton
          disabled={!this.isItemChecked()}
          onClick={(e) => this.handleReorderClick(e)}
          label={this.getButtonTitle()}
          backgroundColor={`#` + this.props.secondaryColor}
          labelColor="#FFF"
          labelStyle={styles.labelStyle}
        />
      </BottomButtonsWrapperDiv>
    );
  }

  renderPayForOrder() {
    if (this.isTrackOrderTab()) return null;

    return (
      <BottomButtonsWrapperDiv>
        <RaisedButton
          disabled={this.checkDisabled()}
          onClick={(e) => this.handlePayForOrderClick(e)}
          label="Pay For Order"
          backgroundColor={`#` + this.props.secondaryColor}
          labelColor="#FFF"
          labelStyle={styles.payForOrderLabelStyle}
          buttonStyle={styles.payForOrderButtonStyle}
          style={{
            width: '90%',
            boxShadow: "none",
          }}
        />
      </BottomButtonsWrapperDiv>
    );
  }

  renderHeader = () => {
    const {
      subTotal,
      taxTotal,
      discountTotal,
      rewardDiscountTotal,
      tierDiscountTotal,
      adjustedSubtotal,
      orderNumber,
      orderDate,
      statusDescription,
      total,
      deliveryFee
    } = this.state;

    const { isDelivery } = this.props;

    return (
      <OrderDetailsDiv>

        <OrderDetailLeft>
          <div>Receipt #</div>
          <div>Purchase Date</div>
          <div>Order Status</div>
          <div>Original Price</div>
          <div>Tier Discount</div>
          {
            rewardDiscountTotal != 0 &&
            <div> Rewards Discount </div>
          }
          <div>Other Discount</div>
          <div>Subtotal</div>
          <div>Tax</div>
          {isDelivery && <div>Delivery Fee</div>}
          <div>Order Total</div>
        </OrderDetailLeft>

        <OrderDetailRight>
          <div>{orderNumber}</div>
          <div>{formatDate(new Date(orderDate))}</div>
          <div>{statusDescription}</div>
          <div>{subTotal.formatMoney()}</div>
          <div>{tierDiscountTotal.formatMoney()}</div>
          {
            rewardDiscountTotal != 0 &&
            <div> {rewardDiscountTotal.formatMoney()} </div>
          }
          <div>{discountTotal.formatMoney()}</div>
          <div>{adjustedSubtotal.formatMoney()}</div>
          <div>{taxTotal.formatMoney()}</div>
          {isDelivery && <div>{deliveryFee.formatMoney()}</div>}
          <div>{total.formatMoney()}</div>
        </OrderDetailRight>

      </OrderDetailsDiv>
    );
  }

  render() {
    const { isPaymentKiosk } = this.props;
    const { isLoading } = this.state;

    return (
      <div className="orders-wrapper">
        <HeaderDiv>
          <HeaderIconImg style={styles.headerIcon} src={pastOrdersDark} />
          <HeaderTitleDiv>ORDERS</HeaderTitleDiv>
        </HeaderDiv>

        {isLoading && <LinearProgress color="#8BC027" mode="indeterminate" />}

        {this.renderHeader()}

        <div>
          <TabContainerDiv>
            <TabDiv {...(this.isCartTab() && { active: true })} onClick={this.handleTabClick.bind(null, 'cart')} activeColor={this.secondaryColor}>CART</TabDiv>
            <TabDiv {...(this.isTrackOrderTab() && { active: true })} onClick={this.handleTabClick.bind(null, 'track_order')} activeColor={this.secondaryColor} className="track-tab">{this.renderUpdated()}TRACK ORDER</TabDiv>
          </TabContainerDiv>
        </div>
        {this.isCartTab() &&
          <div className="purchased-items-container">
            <div className="purchased-items">
              {this.renderItems()}
            </div>
          </div>
        }
        {
          this.isTrackOrderTab() &&
          <div>
            <TrackOrderDiv>
              <ProgressImg src={this.getProgressImage(this.getProgess())} />
              <TrackText>Processing</TrackText>
            </TrackOrderDiv>
            <OrderHistoryDiv>
              <div style={{ margin: '15px 0', fontSize: '16px' }}>Order Status</div>
              {this.state.history.filter(h => h.status !== 'DRAFT').map((history, i) => this.getOrderProgress(history, i, this.state.history.length))}
            </OrderHistoryDiv>
          </div>
        }
        {!isPaymentKiosk && this.renderReorder()}
        {isPaymentKiosk && this.renderPayForOrder()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    secondaryColor: state.config.secondaryColor,
    history: historyReducer.getOrders(state),
    orders: state.orders.orders,
    isDelivery: isDelivery(state),
    isPaymentKiosk: isPaymentKiosk(state),
    customerName: getFullName(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addProducts: (product) => {
      dispatch(addProducts(product));
      dispatch(cartUpdated());
    },
    getProductById: (catName, productId, customerType) => dispatch(getProductsById(catName, productId, customerType)),
    go: (uri) => dispatch(pushWithQueryParams(uri)),
    showCart: () => dispatch(pushWithQueryParams(checkOutUri)),
    unUpdate: (orderNumber) => dispatch(unUpdateOrder(orderNumber)),
    showMissingPaymentKioskSettingsModal: () => dispatch(openMissingPaymentKioskSettingsModal()),
    showThankYouPaymentKioskModal: () => dispatch(openThankYouPaymentKioskModal()),
    isValidAddProductByCustomerType: (product, customerType) => isValidAddProductByCustomerType(product, customerType),
    openAdultCanOnlyBuyRecModal: () => dispatch(openAdultCanOnlyBuyRecModal()),
    openProductsOutOfStockModal: () => dispatch(openProductsOutOfStockModal()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderHistory);

const ProgressImg = styled.img`
    margin-top: -15px;
    width: 250px;
    height: 65px;
`;

// const DotSpan = styled.span `
//     font-weight: 700;
//     &:before{content:'\00B7';padding-right:5px;};
// `;

const OrderDetailsDiv = styled.div`
  display: flex;
  margin: 20px 0 20px 30px;
  color: ${BODY_TEXT_COLOR};
  font-size: 16px;
`;

const OrderDetailLeft = styled.div`
    color: ${BODY_TEXT_COLOR};
`;

const TrackOrderDiv = styled.div`
  text-align: center;
  border-bottom: 2px solid #E6E6E7;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const TrackText = styled.div`
  color: ${BODY_TEXT_COLOR};
  font-family: Futura-bold;
  font-size: 24px;
  margin-top: -10px;
`;

const OrderDetailRight = styled.div`
  margin-left: 30px;
  text-align: left;
  font-weight: 700;
  color: ${BODY_TEXT_COLOR};
`;

const OrderProgress = styled.div`
  color: ${BODY_TEXT_COLOR};
  display: flex;
  position: relative;
`;

const OrderHistoryDiv = styled.div`
  margin-left: 30px;
  margin-bottom: 15px;
  color: ${BODY_TEXT_COLOR};
`;

const StatusLogo = styled.img`
  position: absolute;
  top: 0;
  left: -1px;
  background: #fff;
  width: 24px;
  height: 24px;
`;

const StatusLogoLast = styled.img`
  position: absolute;
  bottom: 0;
  left: -12px;
  background: #fff;
  width: 28px;
  height: 28px;
`;

const ProgressLine = styled.div`
  height: ${props => props.heightLen ? props.heightLen : 'unset'};
  background: #E6E6E7;
  width: 3px;
  position: absolute;
  left: 10px;
`;

const ProgressStatus = styled.div`
  margin-left: 35px;
  padding-bottom: 20px;
  line-height: 19px;
`;

const TabContainerDiv = styled.div`
  height: 45px;
  width: 100%;
`;

const TabDiv = styled.div`
  color: ${props => props.active ? props.activeColor : NEGATIVE_COLOR};
  border-bottom: ${props => props.active ? '2px solid #7B9E4A' : '2px solid #E6E6E7'};
  float:left;
  width: 50%;
  background-color: #fff;
  height: 100%;
  font-weight: 700;
  border-right: ${props => props.borderRight ? '1px solid #E6E6E7' : 0};
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
`;

const BottomButtonsWrapperDiv = styled.div`
  position: fixed;
  bottom: 15px;
  text-align: center;
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/components/OrderHistory/OrderHistory.jsx